import { render, staticRenderFns } from "./chargeBlock.vue?vue&type=template&id=50d983f0&"
import script from "./chargeBlock.vue?vue&type=script&lang=js&"
export * from "./chargeBlock.vue?vue&type=script&lang=js&"
import style0 from "./chargeBlock.vue?vue&type=style&index=0&id=50d983f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports